import { StepValue } from '../stepper';

export const getTextColor = (value: StepValue): Record<string, string> => {
  if (value === StepValue.COMPLETE) {
    return {
      title: 'textPrimary',
      content: 'textSecondary',
    };
  }

  if (value === StepValue.ACTIVE) {
    return {
      title: 'primary.main',
      content: 'textSecondary',
    };
  }

  return {
    title: 'text.disabled',
    content: 'text.disabled',
  };
};
